/* Supply Access: "Take a closer look" Spotlight (sections/bb-spotlight.liquid), Oct 7.
   Line tabs switch the stage. Dock buttons crossfade the photo and swap the info card.
   On phones "+" opens the facts inside the card, in place. Theme editor: selecting a
   block shows it. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__bbSp) return;
    root.__bbSp = true;
    var tabs = root.querySelectorAll('[data-bb-sp-tab]');

    function showLine(n) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-bb-sp-tab') === String(n);
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
          t.parentElement.scrollTo({ left: t.offsetLeft - (t.parentElement.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        }
      });
      root.querySelectorAll('[data-bb-sp-line]').forEach(function (l) {
        var on = l.getAttribute('data-bb-sp-line') === String(n);
        l.hidden = !on;
        l.classList.toggle('is-on', on);
        if (on) pick(l, 0);
      });
    }

    function pick(line, k) {
      k = String(k);
      line.querySelectorAll('[data-bb-sp-ph]').forEach(function (el) {
        el.classList.toggle('is-on', el.getAttribute('data-bb-sp-ph') === k);
      });
      line.querySelectorAll('[data-bb-sp-card]').forEach(function (el) {
        var on = el.getAttribute('data-bb-sp-card') === k;
        el.classList.toggle('is-on', on);
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
        var go = el.querySelector('.bb-sp__go');
        if (go) go.tabIndex = on ? 0 : -1;
        if (!on) setOpen(el, false);
      });
      line.querySelectorAll('[data-bb-sp-dk]').forEach(function (el) {
        var on = el.getAttribute('data-bb-sp-dk') === k;
        el.classList.toggle('is-on', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) {
          var d = el.parentElement;
          if (d.scrollWidth > d.clientWidth) d.scrollTo({ left: el.offsetLeft - (d.clientWidth - el.offsetWidth) / 2, behavior: 'smooth' });
        }
      });
    }

    function setOpen(card, on) {
      card.classList.toggle('is-open', on);
      var b = card.querySelector('[data-bb-sp-plus]');
      if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-bb-sp-tab]');
      if (t) { showLine(t.getAttribute('data-bb-sp-tab')); return; }
      var d = e.target.closest('[data-bb-sp-dk]');
      if (d) { pick(d.closest('[data-bb-sp-line]'), d.getAttribute('data-bb-sp-dk')); return; }
      var p = e.target.closest('[data-bb-sp-plus]');
      if (p) { var c = p.closest('[data-bb-sp-card]'); setOpen(c, !c.classList.contains('is-open')); }
    });

    /* arrow keys move along the tabs */
    root.addEventListener('keydown', function (e) {
      var t = e.target.closest('[data-bb-sp-tab]');
      if (!t || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      var list = Array.prototype.slice.call(tabs);
      var i = list.indexOf(t) + (e.key === 'ArrowRight' ? 1 : -1);
      if (i < 0 || i >= list.length) return;
      e.preventDefault();
      list[i].focus();
      showLine(list[i].getAttribute('data-bb-sp-tab'));
    });

    /* swipe the stage on phones to move between products */
    root.querySelectorAll('.bb-sp__stage').forEach(function (stage) {
      var sx = 0, sy = 0, on = false;
      stage.addEventListener('touchstart', function (e) { var q = e.touches[0]; sx = q.clientX; sy = q.clientY; on = true; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!on) return; on = false;
        var q = e.changedTouches[0], dx = q.clientX - sx, dy = q.clientY - sy;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        var line = stage.closest('[data-bb-sp-line]');
        var all = line.querySelectorAll('[data-bb-sp-dk]');
        var cur = line.querySelector('[data-bb-sp-dk].is-on');
        var i = Array.prototype.indexOf.call(all, cur) + (dx < 0 ? 1 : -1);
        if (i >= 0 && i < all.length) pick(line, all[i].getAttribute('data-bb-sp-dk'));
      });
    });

    root.__bbSpShow = function (blockEl) {
      var card = blockEl.closest('[data-bb-sp-card]');
      if (card) {
        var line = card.closest('[data-bb-sp-line]');
        showLine(line.getAttribute('data-bb-sp-line'));
        pick(line, card.getAttribute('data-bb-sp-card'));
      } else if (blockEl.hasAttribute('data-bb-sp-tab')) {
        showLine(blockEl.getAttribute('data-bb-sp-tab'));
      }
    };
  }

  function boot() { document.querySelectorAll('[data-bb-sp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-bb-sp]')); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-bb-sp]');
    if (root && root.__bbSpShow) root.__bbSpShow(e.target);
  });
})();
